module.exports = __webpack_public_path__ + "static/media/git.62df7b3f.png";